import CRUDService from "./CRUDService";
class ReportAdminViewService extends CRUDService {
    constructor() {
        super("report-admin-view");
    }
}

export default new ReportAdminViewService();
